export default __webpack_public_path__ + "static/media/love_this.aecac81a.svg";